import {
  createCanMoveHereCreate,
  nodeDesignsReducerCreate,
  type NodeDesignsEvent,
} from "@skilitics/nautilus-core-designer-data";

import { effectLifecycleEventName, nodeLifecycleEventName, publishEvent } from "../events/index.ts";
import type { GetManifestByTypeId } from "../types/index.ts";

interface Options {
  getManifest: GetManifestByTypeId;
  options?: Partial<Omit<Required<Parameters<typeof nodeDesignsReducerCreate>>[0], "clientOptions">>;
}

export const createReducer = ({ getManifest, options }: Options) =>
  nodeDesignsReducerCreate({
    clientOptions: {
      canMoveHere: createCanMoveHereCreate((typeId) => getManifest(typeId).terminus),
    },
    ...options,
  });

export const publishNodeDesignsEvent = (event: NodeDesignsEvent) => {
  const { type } = event;
  switch (type) {
    case "NODE_ADDED":
    case "NODE_REMOVED": {
      const { typeId, config, id } = event;
      publishEvent(nodeLifecycleEventName(type, typeId, id), { id, typeId, config });
      break;
    }
    case "NODE_UPDATED": {
      const { typeId, id, ...data } = event;
      publishEvent(nodeLifecycleEventName(type, typeId, id), { typeId, ...data });
      break;
    }
    case "NODE_SLOT_MOVED": {
      const { from, to } = event;
      publishEvent(nodeLifecycleEventName(type), { from, to });
      break;
    }
    case "EFFECT_ADDED":
    case "EFFECT_REMOVED": {
      const { buildableName, config, nodeId, id } = event;
      publishEvent(effectLifecycleEventName(type, nodeId, buildableName, id), { id, config, nodeId });
      break;
    }
  }
};
